import { css } from "@emotion/css";
import { InfiniteSpinnerIcon } from "../icons";

export const LoadingLayout: React.FC = () => {
  return (
    <div
      className={css`
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <InfiniteSpinnerIcon fill="highlight/1" style={{ height: "58px" }} />
    </div>
  );
};
